module.exports = __webpack_public_path__ + "assets/electricBill.34fed449.svg";